import { swRequest } from "@sourcewhale/core";

export const getAttachments = () =>
  swRequest({
    path: "/api/attachments/get_all",
    method: "GET",
    params: { includeDeleted: true, includeTeamAttachments: true },
  });
